import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DataspaceWorkspaceStat } from '../../models/dataspace-workspace.models';

@Component({
  standalone: false,
  selector: 'app-dataspace-report-workspace-layout',
  templateUrl: './dataspace-report-workspace-layout.component.html',
  styleUrls: ['./dataspace-report-workspace-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataspaceReportWorkspaceLayoutComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() stats: DataspaceWorkspaceStat[] = [];
}
